import $ from "jquery";

const noLeftScroll = () => {
  // Ne bloquer que le scroll horizontal du body, pas des conteneurs spécifiques
  // Cela permet aux conteneurs avec overflow-x: auto (comme .table-responsive) de fonctionner
  const body = $('body');
  body.on("scroll", function () {
    if (body.scrollLeft() !== 0) {
      body.scrollLeft(0);
    }
  });
};

export { noLeftScroll };
